import { CLUMSE_SEARCH_FEE_USD } from "./procurementPricing";

/**
 * Home savings ledger: illustrative rows by work type (same flat search fee).
 */
export const HOME_SAVINGS_TIER_ROWS = [
  {
    id: "minor",
    searchFee: CLUMSE_SEARCH_FEE_USD,
    tierLabel: "Small fixes",
    workTypesLine: "Handyman · plumbing · fixtures · drywall",
    exampleTitle: "Kitchen faucet + shutoffs",
    exampleDesc: "Typical service-call price vs.\u00A0a scoped bid.",
    marketBid: 425,
    targetBid: 155,
  },
  {
    id: "major",
    searchFee: CLUMSE_SEARCH_FEE_USD,
    tierLabel: "Major systems",
    workTypesLine: "HVAC · water heaters · roofs · panels · plumbing",
    exampleTitle: "HVAC repair (capacitor + motor)",
    exampleDesc: "Typical retail price vs.\u00A0competitive bids.",
    marketBid: 1850,
    targetBid: 820,
  },
  {
    id: "capex",
    searchFee: CLUMSE_SEARCH_FEE_USD,
    tierLabel: "Large projects",
    workTypesLine: "Remodels · kitchens · baths · basements · additions",
    exampleTitle: "Primary bath remodel (wet area)",
    exampleDesc: "Rough allowance quotes vs.\u00A0detailed bids.",
    marketBid: 38500,
    targetBid: 26800,
  },
];
